exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".money-input{min-width:300px}.valid{color:#67c23a}.invalid{color:red}.user-msg{margin:0}.code{color:#fff;background:#232323;padding:30px 0;overflow-x:scroll}.code code{font:normal 10pt Consolas,Monaco,monospace}.code .copy-button{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-182e05d0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 163
// module chunks = 0